import { type ColDef } from "ag-grid-community"
import { ERP_ETD_TOOLTIP, IncomingOrdersOverviewTableColumn } from "~/constants/incomingOrders"
import { createDateColumn } from "~/utils/columnTemplates"

/** ERP ETD column shared by the incoming-orders list and the calendar's order dialog. */
export function createErpEtdColumn<T>({
  hide,
  width,
}: {
  hide: boolean
  width?: number
}): ColDef<T> {
  return createDateColumn<T>({
    colId: IncomingOrdersOverviewTableColumn.ExpectedDepartureDate,
    field: "expectedDepartureDate" as ColDef<T>["field"],
    headerName: "ETD",
    headerTooltip: ERP_ETD_TOOLTIP,
    aggFunc: "unique",
    filter: true,
    hide,
    width,
  })
}
